var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.isOnline)?_vm._t("online"):_vm._e(),(_vm.isOffline)?_vm._t("offline"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }